<!-- Menu principal  menutitulo="titulo del modulo en el que estamos con el nombre como se encuentra en enviroment" menuactual="nombre del hub donde estamos como se especifico en el routing"-->
<app-sistema-menu menutitulo="Catalogo" menuactual="catalogo"></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda menutitulo="titulo del modulo enviroment" -->
        <app-sistema-menu-aside menuactual="Catalogo"></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <section class="hero is-primary">
                <div class="hero-body">
                    <nav class="level columns">
                        <!-- Left side -->
                        <div class="level-left column is-3">
                            <div class="level-item">
                                <p class="title">
                                    <span *ngIf="!cargando || !cargando" class="icon is-medium">
                                        <i class="icon-edit-1"></i>
                                    </span>
                                    <span *ngIf="cargando || cargando" class="icon is-medium">
                                        <i class="icon-worldwide fa-spin"></i>
                                    </span> Artículo
                                </p>
                            </div>
                        </div>

                        <!-- Right side -->
                        <div class="level-right column">
                            <div class="level-item">
                                <div class="field is-grouped" style=" width: 100%; ">
                                    <div class="control has-icons-left is-expanded" *ngIf="codigo_barras_activo">
                                        <input autofocus class="input is-success is-medium" (keydown)="buscar_articulo($event)" id='buscarArticulo' type="text" placeholder="Escanea el codigo de barra, o cambia la forma de busqueda">
                                        <span class="icon is-medium is-left">
                                            <i class="fa fa-barcode"></i>
                                        </span>
                                    </div>
                                    <div class="control has-icons-left is-expanded" *ngIf="!codigo_barras_activo">
                                        <input autofocus autocomplete="off" ngui-auto-complete [source]="observableSource.bind(this)" [list-formatter]="autocompleListFormatter" [close-on-focusout]="false"
                                            id='buscarArticulo' value-property-name="clave" display-property-name="nombre" path-to-data=""
                                            loading-text="Cargando..." no-match-found-text="No hay resultados." (valueChanged)="select_articulo_autocomplete($event)"
                                            min-chars="1" class="input is-success is-medium" type="text" placeholder="Escribe el nombre del producto, o cambia la forma de busqueda">
                                        <span class="icon is-medium is-left">
                                            <i class="icon-search3"></i>
                                        </span>
                                    </div>
                                    <div class="control">
                                        <div class="b-checkbox is-info is-circular is-medium">
                                            <input id="codigo_barras_activo_t" name="codigo_barras_activo" value="true" class="styled" type="radio" (click)="cambiar_busqueda()"
                                                [checked]="codigo_barras_activo">
                                            <label for="codigo_barras_activo_t">
                                                Buscar por codigo de barras
                                            </label>
                                            <div style="height: 12px;"></div>
                                            <input id="codigo_barras_activo_f" name="codigo_barras_activo" value="false" class="styled" type="radio" (click)="cambiar_busqueda()"
                                                [checked]="!codigo_barras_activo">
                                            <label for="codigo_barras_activo_f">
                                                Buscar por texto libre
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </nav>
                </div>
            </section>
            <!-- Opciones y busqueda -->
            <div id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block;" [style.height.px]="tamano-160">
                <br>
                <div class="columns">
                    <div class="column is-6-desktop is-offset-3-desktop is-10-tablet is-offset-1-tablet is-12-mobile">
                        <div class="card">
                            <div class="card-image">
                                
                            </div>
                            <div class="card-content">
                                <div class="media">

                                    <div class="media-content">
                                        <p class="title is-2-desktop is-3-tablet is-5-mobile">Precio: {{articulo.precio | currency:configuracion.sucursal.moneda:'symbol'}}</p>
                                        <p class="subtitle is-3-desktop is-4-tablet is-6-mobile">Nombre: {{articulo.nombre}}</p>
                                    </div>
                                </div>

                                <div class="content">
                                    {{articulo.descripcion}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            <!-- Paginación para la lista  -->

        </div>
    </div>
</div>
